import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Выбор документа ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_Column = _resolveComponent("Column")!
  const _component_SearchDate = _resolveComponent("SearchDate")!
  const _component_TablePage = _resolveComponent("TablePage")!
  const _component_XModal = _resolveComponent("XModal")!

  return (_openBlock(), _createBlock(_component_XModal, { ref: "XModal" }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_TablePage, {
        ref: "TablePage",
        "main-url": "/digital-docs",
        "preserve-load-table-items-on-create": "",
        onTableItemsClick: $options.tableItemsClick
      }, {
        tableColumns: _withCtx((TableProps) => [
          _createVNode(_component_Column, {
            sortable: true,
            field: "title",
            "filter-field": "title"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_SearchInput, {
                modelValue: TableProps.filters['title'],
                "onUpdate:modelValue": ($event: any) => ((TableProps.filters['title']) = $event),
                label: "Представление документа"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_Column, {
            sortable: true,
            field: "reg_date"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_SearchDate, {
                modelValue: TableProps.filters['reg_date'],
                "onUpdate:modelValue": ($event: any) => ((TableProps.filters['reg_date']) = $event),
                label: "Дата"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.dateToDMY(slotProps.data?.['reg_date'] * 1000)), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_Column, {
            sortable: true,
            field: "reg_num",
            "filter-field": "reg_num"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_SearchInput, {
                modelValue: TableProps.filters['reg_num'],
                "onUpdate:modelValue": ($event: any) => ((TableProps.filters['reg_num']) = $event),
                label: "Номер"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_Column, {
            sortable: true,
            field: "type_title",
            "filter-field": "type_title"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_SearchInput, {
                modelValue: TableProps.filters['type_title'],
                "onUpdate:modelValue": ($event: any) => ((TableProps.filters['type_title']) = $event),
                label: "Вид"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_Column, {
            sortable: true,
            field: "reg_org_title",
            "filter-field": "reg_org_title"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_SearchInput, {
                modelValue: TableProps.filters['reg_org_title'],
                "onUpdate:modelValue": ($event: any) => ((TableProps.filters['reg_org_title']) = $event),
                label: "Орган регистрации"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["onTableItemsClick"])
    ]),
    _: 1
  }, 512))
}